import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useEditGoalInDashboard = () => {
  const { api } = useApiClient();

  const EditGoals = useCallback(
    async (data) => {
      try {
        const response = await api.post("/api/update-goal-edit-status", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );
  return { EditGoals };
};
